<template>
  <Dropdown
    key="languages-dropdown"
    class="border-b-0 pr-0 -mr-6"
    @toggled="handleToggle"
  >
    <template #button>
      <div class="flex items-center sm:w-auto w-full" data-test="menu-languages">
        <Flag :lang="language.lang" />
        <span class="font-bold w-[21px] text-center">{{ language.lang.split('-')[0] | uppercase }}</span>
        <span class="ml-2">
        <IconCaretRight  class="text-black-alt-500 rotate-90" />
       </span>
      </div>
    </template>
    <template #content>
      <ul class="sm:py-2 sm:-ml-2 overflow-y-auto !h-[266px] !py-0">
        <li
          v-for="item in languages"
          :key="`lang-${item.lang}`"
          :data-test="`menu-language-${item.lang}`"
          v-show="item.lang !== language.lang"
          class="h-[40px]"
        >
          <a
            :href="`//${item.domain}/`"
            class="flex items-center whitespace-nowrap block px-6 sm:px-4 border-athens hover:no-underline hover:text-black sm:hover:bg-gray-200 !py-1"
            :class="{
              'bg-gray-100 text-black font-medium !py-1': item.lang === language.lang,
            }"
            data-test="menu-language-url"
          >
            <Flag :lang="item.lang" data-test="menu-language-flag" />
            <span class="ml-2" :class="item.lang !== language.lang || 'font-bold'">{{ item.native_name }}</span>
            <svg
              v-if="item.lang === language.lang"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="w-5 h-5 ml-2 stroke-current text-green-600"
              fill="none"
              role="img"
              aria-label="Checkmark"
            >
              <path
                d="M5 13l4 4L19 7"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        </li>
      </ul>
    </template>
  </Dropdown>
</template>

<script>
import Dropdown from '~/components/header/Dropdown.vue';
import Flag from '~/components/icons/Flag.vue';
import IconCaretRight from '~/components/icons/IconCaretRight.vue';

export default {
  filters: {
    uppercase: (value) => value.toUpperCase(),
  },

  components: {
    Dropdown,
    Flag,
    IconCaretRight,
  },

  computed: {
    languages() {
      const sorted = [ ...this.$store.state.languages ]
        .sort((a, b) => a.native_name.localeCompare(b.native_name));

        const currentLang = sorted.find(l => l.lang === this.language.lang);
        if (!currentLang) return sorted;
        const others = sorted.filter(l => l.lang !== this.language.lang);
        return [ currentLang, ...others ];
    },
    language() {
      return this.$store.state.language;
    },
  },
  methods: {
    handleToggle(expanded) {
      this.$emit('toggled', expanded);
    },
  },
};
</script>
